import { Button, ButtonType, Tag, TagColor } from '@isbj-redesign/frontend-components'
import AnfragenIcon from '@isbj-redesign/icons/FaFileExportSolid'
import filesize from 'filesize'
import React, { useMemo } from 'react'
import classes from './SammelanfrageFooter.module.css'
import { SammelanfrageModal, useModal } from './SammelanfrageModal'
import { Dokument } from './types'

// 10 MB max size
const maxSize = 10 * 1024 * 1024

export function SammelanfrageFooter({ selected, reset }: { selected: Dokument[]; reset: () => void }) {
    const { isVisible, openModal, closeModal } = useModal()
    const fullSize = useMemo(() => selected.reduce((acc, val) => acc + val.groesse, 0), [selected])
    const isOversize = useMemo(() => fullSize > maxSize, [fullSize])

    return selected.length > 1 ? (
        <div className={`bg-white py-3 px-4 ${classes.sammelanfrageFooter}`}>
            <div className="d-flex justify-content-between align-items-center">
                <div>
                    <Tag color={isOversize ? TagColor.Red : TagColor.Blue}>{selected.length}</Tag>
                    <span className="ml-2">
                        {selected.length < 2 ? 'Eintrag ausgewählt' : 'Einträge ausgewählt'}
                        <span className={`ml-1 ${isOversize ? 'font-weight-bold' : ''}`}>({filesize(fullSize, { locale: 'de' })})</span>
                    </span>
                </div>
                <div>
                    <Button title="Filter zurücksetzen" type={ButtonType.Reset} onClick={reset} color="link" className="mx-1 text-muted">
                        Auswahl zurücksetzen
                    </Button>
                    <Button onClick={() => openModal()} disabled={isOversize} title={isOversize ? 'Die Auswahl ist zu groß' : undefined}>
                        <AnfragenIcon /> Auswahl anfragen
                    </Button>
                </div>
            </div>
            <SammelanfrageModal show={isVisible} onClose={closeModal} selected={selected} resetSelected={reset} fullSize={fullSize} />
        </div>
    ) : null
}
